import { Card } from '@keboola/design';
import { ShieldCheck } from '@keboola/design/icons';

import { MfaEnrolment } from './MfaEnrolment';

/**
 * Blocks the vendor dashboard until the user enrols in TOTP.
 *
 * - Not dismissible: the whole signed-in area sits behind it.
 * - Wins over the select-vendor gate — ordering in `features/vendors/gate.ts`.
 * - The enrolment itself is {@link MfaEnrolment}, shared with the profile page.
 */
export function EnableMfaGate() {
  return (
    <Card className="tw:mx-auto tw:max-w-lg">
      <Card.Content className="tw:flex tw:flex-col tw:items-center tw:gap-4 tw:text-center">
        <div className="tw:flex tw:size-12 tw:items-center tw:justify-center tw:rounded-full tw:bg-muted tw:text-muted-foreground">
          <ShieldCheck />
        </div>
        <Card.Title as="h1">Multi-factor authentication</Card.Title>
        <p className="tw:m-0 tw:text-sm tw:text-muted-foreground">
          To continue using the Developer Portal, you must enable multi-factor authentication.
        </p>

        <MfaEnrolment label="Set up using an app" size="large" />
      </Card.Content>
    </Card>
  );
}
